import { useEffect, useState } from 'react';
import { isClient } from '@utils/helpers';

const getMatch = query => window.matchMedia(query);

const parseQueryString = (query = '') =>
  typeof query === 'string'
    ? query.replace(/@media only screen and/g, '').trim()
    : '';

const useMediaQuery = (query, defaultState = false) => {
  const parseAndMatch = s => getMatch(parseQueryString(s));
  const [state, setState] = useState(
    isClient ? () => parseAndMatch(query).matches : defaultState
  );

  useEffect(() => {
    let mounted = true;
    const mql = parseAndMatch(query);

    const onChange = () => {
      if (!mounted) {
        return;
      }
      setState(!!mql.matches);
    };

    if (isClient) {
      mql.onchange = onChange;
      setState(mql.matches);
    }

    return () => {
      mounted = false;
      mql.onchange = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, [query, isClient]);

  return state;
};

export default useMediaQuery;
